export default __webpack_public_path__ + "static/media/financialsituation3help1.d08d2ea9.png";